import { FC } from 'react'
import { DotsContainer, Dot } from './styled'
type Props = {
  id: number
}
const Dots: FC<Props> = ({ id }) => {
  return (
    <DotsContainer>
      <Dot $color={id === 0}></Dot>
      <Dot $color={id === 1}></Dot>
      <Dot $color={id === 2}></Dot>
      <Dot $color={id === 3}></Dot>
    </DotsContainer>
  )
}
export default Dots
